import React from 'react';
import config from '../../../../../common-sk-doc/src/config';
import LottieAnimation from '../Lottie/LottieAnimation';

const Splash: React.FC<{
  color?: string;
  animated?: boolean;
  logo?: boolean;
}> = ({ color, animated = false, logo = false }) => {
  return (
    <div className="splash text-center py-5 m-3" style={{ color: color }}>
      {animated ? (
        <div>
          {/* <img src={config.ASSETS_PATH + '/images/loading/logo_loading.gif'} width={70} alt="" /> */}
          <LottieAnimation
            path={config.ASSETS_PATH + '/lottie/loading/logo_loading.json'}
            width={70}
          />
        </div>
      ) : (
        <>
          {logo && (
            <div>
              <img
                src={config.ASSETS_PATH + '/logo192.svg'}
                alt=""
                width={100}
              />
            </div>
          )}
        </>
      )}
      <div className="text-center">
        <img
          src={config.ASSETS_PATH + '/images/loading/dots.svg'}
          height={50}
          alt=""
        />
      </div>
    </div>
  );
};

export default Splash;
